import { useState } from "react";

export default function useIPInfo() {
    const [IPInfoObject, setIPInfoObject] = useState({});

    const getIPinformation = async () => {
        /*const response = await fetch('https://geolocation-db.com/json/');
        const data = await response.json();
        setIPInfoObject(data);
        console.table(data); */
        fetch("https://geolocation-db.com/json/")
            .then(response => {
                return response.json();
            }, "jsonp")
            .then(res => {
                setIPInfoObject(res);
            })
            .catch(err => {})
    }

    return { getIPinformation, IPInfoObject }
}